import request from '@/utils/request'


export function getRecentContractDataList(data) {
  return request({
      url: '/api/common/v1/task/recently',
      method: 'post',
      data
  })
}

// 获取合同空间banner
export function getSpaceDetailInfo(data) {
  return request({
    url: '/api/common/v1/user/getSpaceDetailInfo',
    method: 'post',
    data
  })
}

// 获取合同空间菜单项
export function contractCountApi(data) {
  return request({
    url: '/api/common/v1/task/getStatusTotal',
    method: 'post',
    data
  })
}

// 根据查询条件获取合同列表
export function getTaskList(data) {
  return request({
    url: '/api/common/v1/task/list',
    method: 'post',
    data
  })
}

// 发送合同
export function updateTaskStatus2Send(data) {
  return request({
    url: '/api/common/v1/task/updateTaskStatus2Send',
    method: 'post',
    data
  })
}

// 删除合同
export function updateTaskStatus2Delete(data) {
  return request({
    url: '/api/common/v1/task/updateTaskStatus2Delete',
    method: 'post',
    data
  })
}

// 拒签合同
export function updateTaskStatus2Reject(data) {
  return request({
    url: '/api/common/v1/task/updateTaskStatus2Reject',
    method: 'post',
    data
  })
}


// 下载合同
export function downloadContractApi(data) {
  return request({
    url: '/api/common/v1/tool/downloadFinishedPdf',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

// 下载合同（可批量版本）
export function batchDownloadContractApi(data) {
  return request({
    url: '/api/common/v1/tool/downloadFinishedTasks',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

// 下载合同前摇，可获得文件类型（可批量版本）
export function downloadFinishedTasksAfter(data) {
  return request({
    url: '/api/common/v1/tool/downloadFinishedTasksAfter',
    method: 'post',
    data: data
  })
}


export function downloadContracExcelApi(data) {
  return request({
    url: '/api/common/v1/task/exportTaskExcel',
    method: 'post',
    responseType: 'blob',
    data
  })
}

export function deleteContractApi(data) {
  return request({
    url: '/contract/delete',
    method: 'post',
    data
  })
}
export function sendContractApi(data) {
  return request({
    url: '/contract/sendContract',
    method: 'post',
    data
  })
}

// 撤回合同
export function recallContractApi(data) {
  return request({
    url: '/api/common/v1/task/updateTaskStatus2recall',
    method: 'post',
    data
  })
}

export function returnContractApi(data) {
  return request({
    url: '/contract/return',
    method: 'post',
    data
  })
}

export function sendApproveApi(params) {
  return request({
    url: '/contract/sendApprove',
    method: 'get',
    params
  })
}

export function recallApproveApi(params) {
  return request({
    url: '/contract/recallApprove',
    method: 'get',
    params
  })
}

export function downloadContractEvidenceApi(contractId) {
  return request({
    url: '/contract/createEvidence?contractId=' + contractId + '&nocache=' + new Date().getTime(),
    method: 'get',
    responseType: 'blob'
  })
}

export function taskList(data) {
  return request({
    url: '/api/common/v1/task/list',
    method: 'post',
    data
  })
}

export function signBeforeCheck(data) {
  return request({
    url: '/api/common/v1/task/signBeforeCheck',
    method: 'post',
    data
  })
}
export function updateBatchTaskStatus2Send(data) {
  return request({
    url: '/api/common/v1/task/updateBatchTaskStatus2Send',
    method: 'post',
    data
  })
}
export function getBatchSignSealInfo(data) {
  return request({
    url: '/api/common/v1/task/getBatchSignSealInfo',
    method: 'post',
    data
  })
}
export function signBatchProcessPosition(data) {
  return request({
    url: '/api/common/v1/task/signBatchProcessPosition',
    method: 'post',
    data
  })
}

